import { inject, provide } from 'vue'

import useBaseModal from '@/composables/base/modal/useBaseModal'

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function useBaseMenuModal<T = any> (key: symbol) {
  return useBaseModal<T>(
    key,
    {
      position: 'bottom',
      transition: 'bottom'
    }
  )
}

export default function useMenuModal<T> (arg1?: symbol): ReturnType<typeof useBaseMenuModal<T>> {
  const key = typeof arg1 === 'symbol' ? arg1 : Symbol('base-menu-modal')
  const result = inject<ReturnType<typeof useBaseMenuModal<T>> | undefined>(key, undefined)

  if (result === undefined) {
    const newResult = useBaseMenuModal<T>(key)
    provide(key, newResult)
    return newResult
  }

  return result
}
